import { createConfig, http } from 'wagmi';
import { injected } from 'wagmi/connectors';

// Custom BSC Mainnet chain configuration with Alchemy RPC
const bscMainnet = {
  id: 56,
  name: 'BSC Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: {
      http: ['https://api-bsc-mainnet-full.n.dwellir.com/c6fd7c04-24d6-4cb1-881b-c3c3a43ba755'],
    },
    public: {
      http: ['https://api-bsc-mainnet-full.n.dwellir.com/c6fd7c04-24d6-4cb1-881b-c3c3a43ba755'],
    },
  },
  blockExplorers: {
    default: {
      name: 'BSCScan',
      url: 'https://bscscan.com',
    },
  },
};

// Custom Xphere Mainnet chain configuration
const xphereMainnet = {
  id: 20250217,
  name: 'Xphere Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'XPH',
    symbol: 'XPH',
  },
  rpcUrls: {
    default: {
      http: ['https://xp-mainnet.rpc.xplorium.xyz'],
    },
    public: {
      http: ['https://xp-mainnet.rpc.xplorium.xyz'],
    },
  },
  blockExplorers: {
    default: {
      name: 'XploriumScan',
      url: 'https://xploriumscan.com',
    },
  },
};

// Mainnet-only chains
const getChains = () => {
  return [bscMainnet, xphereMainnet];
};

// Helper function to detect installed wallet extensions
const getInstalledWallets = () => {
  const wallets = [];
  
  if (typeof window === 'undefined') return wallets;
  
  // Check for MetaMask
  if (window.ethereum?.isMetaMask && !window.ethereum.isRabby) {
    wallets.push({
      id: 'metaMask',
      name: 'MetaMask',
      provider: window.ethereum
    });
  }
  
  // Check for Rabby (detected by rabby global)
  if (window.rabby?.ethereum) {
    wallets.push({
      id: 'rabby',
      name: 'Rabby Wallet',
      provider: window.rabby.ethereum
    });
  }
  
  // Check for Trust Wallet
  if (window.trustwallet?.ethereum) {
    wallets.push({
      id: 'trustWallet',
      name: 'Trust Wallet',
      provider: window.trustwallet.ethereum
    });
  }
  
  // Check for Coinbase Wallet
  if (window.coinbaseWalletExtension) {
    wallets.push({
      id: 'coinbaseWallet',
      name: 'Coinbase Wallet',
      provider: window.coinbaseWalletExtension
    });
  }
  
  // Check for other injected providers
  if (window.ethereum && !window.ethereum.isMetaMask && !window.rabby?.ethereum && !window.trustwallet?.ethereum) {
    wallets.push({
      id: 'injected',
      name: 'Browser Extension Wallet',
      provider: window.ethereum
    });
  }
  
  return wallets;
};

// Get all connectors dynamically - only wallet extensions
const getAllConnectors = () => {
  const connectors = [];
  
  // Add only detected wallet extensions
  if (typeof window !== 'undefined') {
    const detectedWallets = getInstalledWallets();
    detectedWallets.forEach(wallet => {
      connectors.push(
        injected({
          target: () => ({
            id: wallet.id,
            name: wallet.name,
            provider: wallet.provider,
          }),
        })
      );
    });
  }
  
  return connectors;
};

// Create Wagmi configuration with WalletConnect + detected wallets
export const config = createConfig({
  chains: getChains(),
  connectors: getAllConnectors(),
  transports: {
    [bscMainnet.id]: http(),
    [xphereMainnet.id]: http(),
  },
});

// Export chain configurations for use in components
export { bscMainnet, xphereMainnet };
